import { __decorate } from "tslib";
import { DeferCondition } from '../common.js';
import { ConditionalDeferHandler } from './conditional-defer-handler.js';
import { CookieDeferHandler } from './cookie-defer-handler.js';
import { IdleDeferHandler } from './idle-defer-handler.js';
import { ImmediateDeferHandler } from './immediate-defer-handler.js';
import { VisibleDeferHandler } from './visible-defer-handler.js';
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
let DeferHandlerService = class DeferHandlerService {
    createHandler(component) {
        let deferCondition = DeferCondition.NONE;
        for (const [key, value] of Object.entries(DeferCondition)) {
            if (component.hasAttribute(`defer:on:${value}`)) {
                deferCondition = DeferCondition[key];
            }
        }
        const handler = this.getDeferHandler(component, deferCondition);
        return new Promise((resolve) => {
            handler.setHandler().then(() => {
                resolve();
            });
        });
    }
    getDeferHandler(component, deferCondition) {
        if (deferCondition === DeferCondition.VISIBLE) {
            return new VisibleDeferHandler(component);
        }
        else if (deferCondition === DeferCondition.IDLE) {
            return new IdleDeferHandler(component);
        }
        else if (deferCondition === DeferCondition.COOKIE) {
            return new CookieDeferHandler(component);
        }
        else if (deferCondition === DeferCondition.CONDITIONAL) {
            return new ConditionalDeferHandler(component);
        }
        return new ImmediateDeferHandler(component);
    }
};
DeferHandlerService = __decorate([
    SingletonService
], DeferHandlerService);
export { DeferHandlerService };
//# sourceMappingURL=defer-handler.service.js.map